<div class="container mt-3 mx-auto">
    <div class="alert alert-info" *ngIf="!inadimplencias || !inadimplencias.length">
        Não foram encontradas inadimplementos operacionais com os filtros informados.
    </div>

    <div *ngIf="inadimplencias && inadimplencias.length">

        <bn-paginacao
            [total]="atributosPaginacao.count"
            [tamanhoPagina]="atributosPaginacao.pageSize" [numPagina]="atributosPaginacao.page"
            [opcoesTamanhoPagina]="opcoesPaginacao" (aoMudar)="mudancaPagina($event)">

            <div class="d-flex align-items-center justify-content-between mb-2">
                <div class="letra-miuda">atualizado em: {{ dataHoraResultado }}</div>
                <button class="btn btn-secondary m-0" type="button" (click)="btnExportarInadimplementos()"
                    placement="top" ngbTooltip="Exporta todos os inadimplementos listados">
                <i class="fa fa-file"></i> Exportar Inadimplementos</button>
            </div>

            <div class="table-responsive">
                <table class="table table-hover">
                    <thead>
                        <tr>
                            <th id="col-agente" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'agenteFinanceiroDestinatario'"
                                    [nomeAtributoExibicao]="'Agente financeiro'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-data-inicio" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'dataInicio'"
                                    [nomeAtributoExibicao]="'Data Inicio'" 
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-data-fim" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'dataFim'" 
                                    [nomeAtributoExibicao]="'Data fim'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                        
                            <th id="col-motivo" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'motivo'" 
                                    [nomeAtributoExibicao]="'Motivo'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>

                            <th id="col-tipo-bloqueio" scope="col">
                                <bn-ordenacao 
                                    [ordenacao]="atributosOrdenacao" 
                                    [atributo]="'tipoBloqueio'" 
                                    [nomeAtributoExibicao]="'Tipo de Bloqueio'"
                                    (aoClickar)="mudancaOrdenacao($event)">
                                </bn-ordenacao>
                            </th>
                            <th></th>
                        </tr>
                    </thead>

                    <tbody>
                        <tr *ngFor="let inadimplencia of inadimplencias">
                            <td>{{ nomeAgenteFinanceiro(inadimplencia.agenteFinanceiro) }}</td>
                            <td>{{ inadimplencia.dataInicio | date: 'dd/MM/yyyy' }}</td>
                            <td>{{ inadimplencia.dataFim ? (inadimplencia.dataFim | date: 'dd/MM/yyyy' ) : 'Ativo'}}</td>
                            <td>{{ inadimplencia.motivo }}</td>
                            <td>{{ labelTipoBloqueio(inadimplencia.tipoBloqueio) }}</td>
                            <td>
                                <div class="d-flex">
                                    <a class="cursor-pointer" *ngIf="permiteExcluir(inadimplencia)">
                                        <i (click)="modalConfirmarExclusao($event, inadimplencia.id)" class="text-danger fa fa-trash" aria-hidden="true" placement="left-top" ngbTooltip="Excluir inadimplemento"></i>
                                    </a>
                                    <a class="ms-2" [routerLink]="['/inadimplencia', inadimplencia.id]" >
                                        <i [class]=" exibeEditar(inadimplencia.dataFim) ? 'fa fa-pencil' : 'fa fa-search'" aria-hidden="true" placement="left-top" [ngbTooltip]=" exibeEditar(inadimplencia.dataFim) ? 'Editar inadimplemento' : 'Visualizar inadimplemento'"></i>
                                    </a>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </bn-paginacao>
        <ng-template #msgTemplateExcluir>
            <span 
              >Esta ação irá EXCLUIR a linha selecionada. </span>
            <br />
            <br />
            Você confirma?
            <br />
          </ng-template>
          <ng-template #botoesPersonalizadosExcluir>
            <button class="btn btn-md btn-success" (click)="excluir()">
              Sim
            </button>
            <button class="btn btn-md btn-danger" (click)="dismissModal()">
              Não
            </button>
          </ng-template>
    </div>
</div>